export default __webpack_public_path__ + "static/media/handleMarker.841d695f.svg";